import { getPriceBodyMatch } from './getPriceBodyMatch';
import { audiUSAModelRegistry } from './constants';
import { getModelNameFromUrl } from './getModelNameFromUrl';
import { getReccomendationsForMLPBuildMix } from './getReccomendationsForMLPBuildMix';
import { getReccomendationsForBuildOnly } from './getReccomendationsForBuildOnly';
import { getReccomendationsForMLPOnly } from './getReccomendationsForMLPOnly';

export function processEngine(
  _currentModel,
  rankedBodyTypes,
  rankedPriceRanges,
  localStorageTracker,
) {
  // let alreadySelectedModels = [];
  let finalReccomendations = [];
  let numberOfReccomendationsNeeded = 3;
  let lastBuildUrl;
  let lastBuildModelName;
  let cureentSavedBuildModelInfo;
  let savedBuildBodyTypes;
  let buildPriceCategory;

  if (localStorageTracker.lastSavedBuildUrl) {
    lastBuildUrl = localStorageTracker.lastSavedBuildUrl;
    lastBuildModelName = getModelNameFromUrl(lastBuildUrl);
    cureentSavedBuildModelInfo = audiUSAModelRegistry[lastBuildModelName];
    savedBuildBodyTypes = cureentSavedBuildModelInfo.bodyType;
    buildPriceCategory = cureentSavedBuildModelInfo.category;
  }

  if (localStorageTracker.lastSavedBuildUrl && localStorageTracker.hasMlpInput) {
    numberOfReccomendationsNeeded = 2;
    finalReccomendations = getReccomendationsForMLPBuildMix(
      lastBuildModelName,
      savedBuildBodyTypes,
      buildPriceCategory,
      rankedBodyTypes,
      rankedPriceRanges,
      numberOfReccomendationsNeeded,
    );
  } else if (localStorageTracker.lastSavedBuildUrl && !localStorageTracker.hasMlpInput) {
    numberOfReccomendationsNeeded = 3;
    finalReccomendations = getReccomendationsForBuildOnly(
      lastBuildModelName,
      savedBuildBodyTypes,
      buildPriceCategory,
      rankedBodyTypes,
      rankedPriceRanges,
      numberOfReccomendationsNeeded,
    );
  } else {
    finalReccomendations = getReccomendationsForMLPOnly(
      rankedBodyTypes,
      rankedPriceRanges,
      numberOfReccomendationsNeeded,
    );
  }

  const firstLinkType = localStorageTracker.lastSavedBuildUrl ? 'resume-build' : 'new-build';

  // get extra 7 reccomendations to simulate model bands, other FAs, other integrations and uses
  const extraReccomendations = getPriceBodyMatch(
    7,
    rankedPriceRanges,
    rankedBodyTypes,
    finalReccomendations,
  );

  const totalTiles = [...finalReccomendations, ...extraReccomendations];

  return { finalReccomendations: totalTiles, buildCTAType: firstLinkType };
}
